import _BaseAPIService from "../_BaseAPIService";
const apiService = _BaseAPIService.instance;
const ProductItemServices = {
  // Define your API functions here
  getList: async (params = {}) => {
    // ✅ Accept params
    const response = await apiService.get("/products", { params }); // ✅ Pass as query params
    return response.data;
  },
  order: async (data) => {
    const response = await apiService.post("/order", data);
    return response.data;
  },
  create: async (formData) => {
    const response = await apiService.post("/products", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },
  getByTable: async (tableId) => {
    const response = await apiService.get(`/order/ongoing/${tableId}`); // ✅ Fixed template literal
    return response.data;
  },
  productDetail: async (id) => {
    const response = await apiService.get(`/products/${id}`); // ✅ Fixed template literal
    return response.data;
  },
  deleteItem: async (id) => {
    const response = await apiService.delete(`/products/${id}`); // ✅ Fixed template literal
    return response.data;
  },
  update: async (id, formData) => {
    try {
      const response = await apiService.put(`/products/${id}`, formData, {
        // ✅ Fixed template literal
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
};
export default ProductItemServices;
